module.exports = __webpack_public_path__ + "static/media/product2.190c65c8.png";